import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function Footer() {
  return <footer style={{
    backgroundColor: 'rgb(15, 15, 15)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    paddingTop: '80px',
    paddingBottom: '80px'
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&family=Cormorant+Garamond:wght@400;600;700&display=swap');`}</style>
      <div className="page-container">
        <div className="flex flex-col md:flex-row md:justify-between gap-12 md:gap-8">

          <div className="flex items-start">
            <img src="https://full-heron.cynergiasites.com/wp-content/uploads/2026/05/REMLOGO2.webp" alt="REM Technologies DME" style={{
            height: '60px',
            width: 'auto',
            marginBottom: '20px'
          }} loading="lazy" />
          </div>

          <div className="flex flex-col" style={{
          maxWidth: '300px'
        }}>
            <h2 style={{
            color: 'rgba(255,255,255,0.95)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '18px',
            fontWeight: '700',
            letterSpacing: '-0.01em',
            lineHeight: '1.2',
            margin: '0 0 4px 0'
          }}>
              REM TECHNOLOGIES DME
            </h2>
            <p style={{
            color: 'rgb(229, 31, 38)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '10px',
            fontWeight: '700',
            lineHeight: '15px',
            letterSpacing: '1px',
            border: '0px solid rgb(229, 31, 38)',
            textTransform: 'uppercase',
            animation: 'none 0s ease 0s 1 normal none running',
            margin: '0'
          }}>
              CLINICAL EQUIPMENT SPECIALISTS
            </p>

            <p style={{
            color: 'oklch(0.707 0.022 261.325)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '22.75px',
            border: '0px solid oklch(0.707 0.022 261.325)',
            animation: 'none 0s ease 0s 1 normal none running',
            marginTop: '20px',
            marginBottom: '0'
          }}>
              Enhancing everyday lives with medical equipment solutions. 25+ years of specialized durable medical equipment, delivered with precision.
            </p>

            <p style={{
            color: 'rgb(229, 31, 38)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '10px',
            fontWeight: '700',
            lineHeight: '15px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            marginTop: '22px',
            marginBottom: '8px'
          }}>
              OUR OFFICES
            </p>

            
            <p style={{
            color: 'oklch(0.551 0.027 264.364)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '12px',
            fontWeight: '300',
            lineHeight: '19.5px',
            border: '0px solid oklch(0.551 0.027 264.364)',
            animation: 'none 0s ease 0s 1 normal none running',
            margin: '0'
          }}>
              <span style={{
              color: 'rgba(255,255,255,0.9)',
              fontWeight: '400'
            }}>East Patchogue:</span> 285 Sills Rd, BLDG 2 STE B
            </p>
          </div>

          <div className="flex flex-col">
            <p style={{
            color: 'rgb(229, 31, 38)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '10px',
            fontWeight: '700',
            lineHeight: '15px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            margin: '0 0 6px 0'
          }}>
              CLINICAL SERVICES
            </p>
            <div style={{
            width: '24px',
            height: '2px',
            backgroundColor: 'rgb(229, 31, 38)',
            marginBottom: '16px'
          }} />
            <ul className="flex flex-col gap-6 list-none p-0 m-0">
              <li style={{
              color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              border: '0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              textAlign: 'left',
              animation: 'none 0s ease 0s 1 normal none running'
            }}>
                <Link to="#" style={{
                color: 'oklch(0.872 0.01 258.338)',
                fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '20px',
                border: '0px solid oklch(0.872 0.01 258.338)',
                textAlign: 'left',
                animation: 'none 0s ease 0s 1 normal none running',
                textDecoration: 'none',
                transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                  Advanced Bracing &amp; Orthotics (C-Brace)
                </Link>
              </li>
              <li style={{
              color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              border: '0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              textAlign: 'left',
              animation: 'none 0s ease 0s 1 normal none running'
            }}>
                <Link to="#" style={{
                color: 'oklch(0.872 0.01 258.338)',
                fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '20px',
                border: '0px solid oklch(0.872 0.01 258.338)',
                textAlign: 'left',
                animation: 'none 0s ease 0s 1 normal none running',
                textDecoration: 'none',
                transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                  Wound Care &amp; NPWT
                </Link>
              </li>
              <li style={{
              color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              border: '0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              textAlign: 'left',
              animation: 'none 0s ease 0s 1 normal none running'
            }}>
                <Link to="#" style={{
                color: 'oklch(0.872 0.01 258.338)',
                fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '20px',
                border: '0px solid oklch(0.872 0.01 258.338)',
                textAlign: 'left',
                animation: 'none 0s ease 0s 1 normal none running',
                textDecoration: 'none',
                transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                  Lymphedema &amp; Compression Systems
                </Link>
              </li>
              <li style={{
              color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              border: '0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              textAlign: 'left',
              animation: 'none 0s ease 0s 1 normal none running'
            }}>
                <Link to="#" style={{
                color: 'oklch(0.872 0.01 258.338)',
                fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '20px',
                border: '0px solid oklch(0.872 0.01 258.338)',
                textAlign: 'left',
                animation: 'none 0s ease 0s 1 normal none running',
                textDecoration: 'none',
                transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                  Diabetic Foot Care &amp; Footwear
                </Link>
              </li>
              <li style={{
              color: 'oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              border: '0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.7)',
              textAlign: 'left',
              animation: 'none 0s ease 0s 1 normal none running'
            }}>
                <Link to="#" style={{
                color: 'oklch(0.872 0.01 258.338)',
                fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '20px',
                border: '0px solid oklch(0.872 0.01 258.338)',
                textAlign: 'left',
                animation: 'none 0s ease 0s 1 normal none running',
                textDecoration: 'none',
                transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
              }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                  Respiratory &amp; Post-Op Recovery DME
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex flex-col">
            <p style={{
            color: 'rgb(229, 31, 38)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '10px',
            fontWeight: '700',
            lineHeight: '15px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            margin: '0 0 6px 0'
          }}>
              SUPPORT &amp; INTAKE
            </p>
            <div style={{
            width: '24px',
            height: '2px',
            backgroundColor: 'rgb(229, 31, 38)',
            marginBottom: '20px'
          }} />

            <div className="flex flex-col gap-6">
              <div className="flex flex-row items-start gap-3">
                <span style={{
                color: 'oklch(0.551 0.027 264.364)',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                </span>
                <div className="flex flex-col">
                  <span style={{
                  color: 'oklch(0.551 0.027 264.364)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '10px',
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  lineHeight: '15px'
                }}>
                    DIRECT REFERRAL LINE
                  </span>
                  <Link to="tel:6317403058" style={{
                  color: 'oklch(0.872 0.01 258.338)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '14px',
                  fontWeight: '300',
                  lineHeight: '20px',
                  border: '0px solid oklch(0.872 0.01 258.338)',
                  textAlign: 'left',
                  animation: 'none 0s ease 0s 1 normal none running',
                  textDecoration: 'none',
                  transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                    631-740-3058
                  </Link>
                </div>
              </div>

              <div className="flex flex-row items-start gap-3">
                <span style={{
                color: 'oklch(0.551 0.027 264.364)',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>
                </span>
                <div className="flex flex-col">
                  <span style={{
                  color: 'oklch(0.551 0.027 264.364)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '10px',
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  lineHeight: '15px'
                }}>
                    EMAIL CORRESPONDENCE
                  </span>
                  <Link to="mailto:contact@remtechnologiesdme.com" style={{
                  color: 'oklch(0.872 0.01 258.338)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '14px',
                  fontWeight: '300',
                  lineHeight: '20px',
                  border: '0px solid oklch(0.872 0.01 258.338)',
                  textAlign: 'left',
                  animation: 'none 0s ease 0s 1 normal none running',
                  textDecoration: 'none',
                  transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
                    contact@remtechnologiesdme.com
                  </Link>
                </div>
              </div>

              <div className="flex flex-row items-start gap-3">
                <span style={{
                color: 'oklch(0.551 0.027 264.364)',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                </span>
                <div className="flex flex-col">
                  <span style={{
                  color: 'oklch(0.551 0.027 264.364)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '10px',
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  lineHeight: '15px'
                }}>
                    SECURE DME INTAKE FAX
                  </span>
                  <span style={{
                  color: 'oklch(0.872 0.01 258.338)',
                  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
                  fontSize: '14px',
                  fontWeight: '300',
                  lineHeight: '20px'
                }}>
                    (516) 646 - 1460
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{
        marginTop: '44px',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        paddingTop: '16px'
      }} className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 md:gap-0">
          <p style={{
          color: 'oklch(0.551 0.027 264.364)',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
          fontSize: '12px',
          fontWeight: '300',
          lineHeight: '19.5px',
          margin: '0'
        }}>
            &copy; 2026 REM Technologies DME. All rights reserved. Registered Provider.
          </p>
          <div className="flex flex-row gap-6 md:gap-8">
            <Link to="#" style={{
            color: 'oklch(0.872 0.01 258.338)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '20px',
            border: '0px solid oklch(0.872 0.01 258.338)',
            textAlign: 'left',
            animation: 'none 0s ease 0s 1 normal none running',
            textDecoration: 'none',
            transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
              Privacy Policy
            </Link>
            <Link to="#" style={{
            color: 'oklch(0.872 0.01 258.338)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '20px',
            border: '0px solid oklch(0.872 0.01 258.338)',
            textAlign: 'left',
            animation: 'none 0s ease 0s 1 normal none running',
            textDecoration: 'none',
            transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
              Terms of Service
            </Link>
            <Link to="#" style={{
            color: 'oklch(0.872 0.01 258.338)',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '20px',
            border: '0px solid oklch(0.872 0.01 258.338)',
            textAlign: 'left',
            animation: 'none 0s ease 0s 1 normal none running',
            textDecoration: 'none',
            transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          }} onMouseEnter={e => e.currentTarget.style.color = 'rgb(229, 31, 38)'} onMouseLeave={e => e.currentTarget.style.color = 'oklch(0.872 0.01 258.338)'}>
              Nondiscrimination Notice
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}